import React from 'react';
import styled from 'styled-components';

import { Flex, Icon } from 'core/components';
import { ReactComponent as InfobloxPortalLogo } from 'app/assets/logos/infoblox-portal-link.svg';
import { getInfobloxPortalUrl } from 'app/util/infobloxPortalUrl';

const StyledWrapper = styled(Flex)`
  border-top: ${({ theme }) => theme.borders.menuDivider};

  a {
    display: flex;
    align-items: center;
    width: 100%;
    color: ${({ theme }) => theme.colors.body};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.navbarMenuCenterBackground};

    a {
      text-decoration: none;
    }
  }
`;

// the source SVG has a wide (~6.5:1) viewBox (136x21); match that ratio so it isn't squashed.
// Passed as explicit width/height + inline style (rather than a styled-components class) since
// svgr's generated component applies its own inline style, which otherwise wins over any CSS class.
const LOGO_HEIGHT = 16;
const LOGO_WIDTH = 104;
const logoStyle = { width: LOGO_WIDTH, height: LOGO_HEIGHT, minWidth: LOGO_WIDTH, flexShrink: 0 };

/**
 * Co-branded link out to the Infoblox portal, shown at the bottom of the Kentik navbar menu
 * for Greenfield customers. The destination URL
 * depends on whether the app is running in the US (iad1/our1) or EU (fra1) region.
 *
 * Navigates the current tab to the Infoblox portal (replacing the Kentik app), rather than
 * opening a new tab, so a plain anchor (not the SPA `Link` component, which intercepts clicks
 * for client-side routing) is used here.
 *
 * @param {function} [onMouseEnter] - should clear any active `hoveringSection` state so the
 *   Top Talkers/Settings sub-panels & active-highlight don't stay stuck on while hovering this link.
 */
function NavbarInfobloxLink({ onClick, onMouseEnter }) {
  return (
    <StyledWrapper py="14px" px={2} mt="auto" flexShrink={0} onMouseEnter={onMouseEnter}>
      <a href={getInfobloxPortalUrl()} onClick={onClick}>
        <InfobloxPortalLogo
          width={LOGO_WIDTH}
          height={LOGO_HEIGHT}
          style={logoStyle}
          role="img"
          aria-label="Infoblox Portal"
        />
        <Icon icon="chevron-right" color="muted" ml="auto" />
      </a>
    </StyledWrapper>
  );
}

export default NavbarInfobloxLink;
